import { gql } from "@apollo/client";

const GET_ACTIVE_SUBSCRIPTION = gql`
  query ActiveSubscription {
    me {
      activeSubscription {
        id
        stripePriceId
        status
        renew
        endDate
        currency
        filter
      }
    }
  }
`;

export default GET_ACTIVE_SUBSCRIPTION;
